<template>
    <ListDetailLayout
        :store="firmwaresStore"
        index-route-name="admin.devices.third-party-firmwares"
        create-permissions="create:device-third-party-firmwares"
        @on-create="$router.push({ name: 'admin.devices.third-party-firmwares.firmware.properties', params: { firmware: 'NEW' } })"
        @on-paginate="(page) => useOnPaginate(page, refreshFirmwares, params)"
        @on-search="(page) => useOnSearch(page, refreshFirmwares, params)"
        placeholder-value="Search for firmware..."
        create-button-admin-page="create-third-party-firmware-admin-btn"
    >
        <template #list>
            <li v-for="firmware in firmwaresStore.getFirmwares" :key="firmware.id">
                <router-link :to="{ name: 'admin.devices.third-party-firmwares.firmware.properties', params: { firmware: firmware.id } }" v-slot="{isActive}">
                    <div :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">
                        <div class="min-w-0">
                            <div class="flex items-start gap-x-3">
                                <p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">{{ firmware.version_number }}</p>
                            </div>
                            <div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
                                <p class="whitespace-nowrap">
                                    {{ firmware.device_type?.name || '-' }} / {{ firmware.device_model?.name || '-' }}
                                </p>
                            </div>
                        </div>
                    </div>
                </router-link>
            </li>
        </template>

        <template #detail>
            <router-view v-if="$route.params.firmware" @on-save="refreshFirmwares" @on-delete="refreshFirmwares"></router-view>
        </template>
    </ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import {mapStores} from "pinia";
import {useFirmwaresStore} from "@/stores/firmwares.js";
import {useOnPaginate, useOnSearch} from "@/Composables/Pagination.js";

export default {
    name: "ThirdPartyFirmwareIndex",
    components: {ListDetailLayout},
    data() {
        return {
            params: {
                include: ['deviceModel', 'deviceType'],
                filter: {
                    purpose: 'third_party',
                },
            }
        };
    },
    methods: {
        useOnPaginate,
        useOnSearch,
        refreshFirmwares() {
            return this.firmwaresStore.indexFirmwares(this.params);
        },
    },
    computed: {
        ...mapStores(useFirmwaresStore),
    },
    async mounted() {
        await this.refreshFirmwares();
    },
};
</script>
